import { Add, AddAPhoto, Delete, Edit, Padding, Refresh } from "@mui/icons-material";
import { Box, IconButton, Stack } from "@mui/material";
import useGlobal from "../util/Global";
import React from "react";
import ActionIconButton from "./IconButton/ActionIconButton";

const CommonCrudColumns = ({
    onEdit,
    onDelete,
    detayAction = [],
    onEditEnable = () => false,
    onDeleteEnable = () => false,
    refesh = () => { }
}) => {

    const { t } = useGlobal();

    return [
        {
            sortable: false,
            searchable: false,
            passItem: true,
            textAlign: 'Center',
            title: 'action',
            execute: (item) => (
                <Box sx={{ textAlign: "center" }}>
                    {detayAction?.map((e) => (
                        <IconButton
                            onClick={() => {
                                const result = e.action(item);
                                if (result?.then) {
                                    result.then(() => refesh());
                                } else {
                                    refesh(); // still call refesh even if it's not async
                                }
                            }}
                            color={e.color}
                            variant='contained'
                            title={e.title}
                            size='small'>
                            {e.icon}
                        </IconButton>
                    ))}

                    {onEdit && <IconButton
                        onClick={() => onEdit(item)}
                        color='warning'
                        variant='contained'
                        title={t('rowActions.update')}
                        disabled={onEditEnable?.(item) ?? false}
                        size='small'>
                        <Edit />
                    </IconButton>
                    }
                    {onDelete && <IconButton
                        onClick={() => onDelete(item)}
                        color='error'
                        variant='contained'
                        title={t('rowActions.delete')}
                        disabled={onDeleteEnable?.(item) ?? false}
                        size='small'>
                        <Delete />
                    </IconButton>
                    }


                </Box>
            ),
        },
    ];
};

export default CommonCrudColumns;


export const CommonTableAction = ({ service, anotherAction = null }) => (
    <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        padding={1}
    >
        {/* Left-aligned Refresh Button */}
        <ActionIconButton
            key="refresh"
            icon={<Refresh />}
            label="Yenileme"
            style={{
                backgroundColor: "#0390fc",
                color: "white",
                "&:hover": {
                    backgroundColor: "#e0e7ff",
                    color: "#0390fc",
                },
            }}
            onClick={() => {
                if (service)
                    service.search();
            }}
        />

        {/* Right-aligned Actions */}
        <Stack direction="row" spacing={1}>
            {anotherAction && React.cloneElement(anotherAction)}
        </Stack>
    </Box>

)
